<template>
    <!-- Contenu du menu affiché (taille passé en property pour simple le réemploi de l'objet)-->
    <div class="overflow-auto pt-2 pb-2" :style="'min-width: ' + MinWidthMenu + '; max-height: ' + MaxHeightMenu + ';'">
        <!-- Menu LEVEL 1 -->
        <b-list-group>
            <b-list-group-item v-for="funcLvl1 in features" v-bind:key="funcLvl1.Path" href="#" 
                class="p-0 border-0" @click="setSelectedlv1(funcLvl1)">
                <b-container v-b-toggle="'collapse-feature-' + funcLvl1.Path" :class="(isSelectedLv1(funcLvl1) ? 'bg-gray-light' : '')" > 
                    <!-- Event over et leave pour l'animation "surligner" --> <!--  @mouseover.self="highlightOver($event,Variant)" @mouseleave.self="highlightLeave($event,Variant)" -->
                    <b-row class="px-3 py-2 ">
                        <b-col cols="1" :class="'border border-'+ Variant +' bg-'+ Variant +'-bg-subtle d-flex align-items-center justify-content-center py-1 img-circle'"  >
                            <font-awesome-icon :icon="funcLvl1.Icon" size="lg" :class="Variant +'-light text-'+ Variant"/>
                        </b-col>
                        <b-col class="d-flex align-items-center justify-content-start h6 font-weight-semibold pt-2 pb-0 pl-3 pr-0">
                            {{ $t(funcLvl1.Name) }}
                        </b-col>
                        <b-col cols="1" class="p-0 d-flex align-items-center justify-content-end">
                            <b-icon :icon="(isSelectedLv1(funcLvl1) ? 'chevron-down' : 'chevron-right')"/>
                        </b-col>
                    </b-row> 
                </b-container>
            
                <!-- Menu LEVEL 2 -->
                <b-collapse :id="'collapse-feature-' + funcLvl1.Path" :visible="isSelectedLv1(funcLvl1)" :class="(isSelectedLv1(funcLvl1) ? 'bg-gray-light' : '')"> <!-- "accordion" pour grouper les "collapse" -->
                    <b-container>
                        <b-row v-for="funcLvl2 in funcLvl1.Features" v-bind:key="'feature-[ ' + funcLvl2.Path + ']'" class="px-3 pt-0 pb-2">
                            <b-col class="p-0">
                                <div :class="(isSelectedFeature(funcLvl2) ? 'rounded-0 border-left-2-only border-' + Variant : '') +' d-flex flex-row align-items-center justify-content-between'">
                                    <b-link @click.stop="selectFeature(funcLvl2)" :class="'pl-2 pr-0 py-2 font-weight-bold text-decoration-none text-' + Variant" href="#" >{{ $t(funcLvl2.Name).toString().toUpperCase() }}</b-link>
                                    <b-icon v-if="funcLvl2.Target" @click.stop="toggleBookmark(funcLvl2)" :icon="funcLvl2.IsBookmark ? 'star-fill' : 'star'" class="p-0" :variant="Variant"/>
                                </div>

                                <!-- Menu LEVEL 3 -->
                                <b-list-group v-if="!funcLvl2.Target" class="rounded-0 d-flex flex-column w-100 pl-2 pr-0 " >
                                    <b-list-group-item v-for="funcLvl3 in funcLvl2.Features" v-bind:key="funcLvl3.Path" @click.stop="selectFeature(funcLvl3)"
                                        :class="'featureMenuItem bg-transparent border-left-2-only ' + (isSelectedFeature(funcLvl3) ? 'border-' + Variant + ' ' : 'border-gray-middle-dark ') + 'pl-3 pr-0 py-0 m-0 d-flex flex-row align-items-center justify-content-between'">
                                        <p :class="(isSelectedFeature(funcLvl3) ? 'font-weight-semibold text-' + Variant : '') + ' text-decoration-none p-0 mb-1'" href="#" >{{ $t(funcLvl3.Name) }}</p>
                                        <b-icon :icon="funcLvl3.IsBookmark ? 'star-fill' : 'star'" :variant="Variant"  class="p-0"
                                            @click.stop="toggleBookmark(funcLvl3)"/>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-collapse>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script lang="ts">
    /** Importe les décorateurs pour utiliser @Component et @Prop */
    import { Component, Prop } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';

    /** Types custom importé depuis /types */
    import Feature from '@/types/Feature';

    /** Classe mère pour faciliter la gestion des tailles d'écrans */
    import { ScreenUtils } from '@/components/commons/Utils';

    /** Fichiers de traductions */
    import locales from "./locales/FeaturesMenu.json";
    import featuresLocales from "@/locales/features.json";

    /** Composant d'affichage du menu listant les fonctions */
    @Component({
        i18n: { messages: locales }
    })
    export default class FeaturesMenu extends ScreenUtils {
        /** Variant de thème utilisé par les pères */
        @Prop({ default: "primary" })
        public Variant!: string;

        /** Indique si le bouton de liste des fonctions est d�sactiv� ou non */
        @Prop({ default: false })
        public Disabled!: boolean;

        /** Largueur horizontale minimal du menu */
        @Prop({ default: "19rem" })
        public MinWidthMenu : string;

        /** Hauteur vertical maximum du menu */                 
        @Prop({ default: "80dvh" })
        public MaxHeightMenu: string;

        /** Liste des fonctions � charger sous forme de menu */
        @Getter('GetFeaturesMenu')
        private features!: Feature[];

        @Getter('GetDefaultFeaturePath')
        private defaultPath! : string;

        // *** Handlers d'événements ***

        /** Temps de réfrence pour le débounce fait "maison" */
        private debounceStart : Date = new Date();
        /** Effectue un débounce afin d'éviter les cliques frénétiques */
        private debounce(delay: number) {
            let currentTime: Date = new Date(); 
            if(currentTime.getTime() - this.debounceStart.getTime() < delay)
                return;
            this.debounceStart = currentTime;
        }

        /** 
         * Lève un "event" pour signaler l'"activation/désactivation" un bookmark sur une fonctionnalité. 
         * @param feature Fonctionnalité visée
         */
        private toggleBookmark(feature: Feature) {
            this.debounce(500); // 500 ms entre 2 cliques pour éviter les soucis de séquences d'appel web API

            this.$emit("toggleBookmarkEvent", feature);
        }

        /** Path de la fonctionnalité en cours d'utilisation */
        private featurePathCurrent: string = "";

        /**
         * Indique si la fonctionnalité est égale au path en cours d'utilisation
         * @param selectedFeature Fonctionnalité à comparer
         */
        private isSelectedFeature(selectedFeature: Feature): boolean{
            return this.featurePathCurrent === selectedFeature.Path;
        }
        /** Chemin de la fonctionnalité mère (level1) sélectionnée. */
        private selectedlv1 : string = "";
        /**
         * Détermine si la fonctionnalité est la mère (level1) de la fonction en cours d'utilisation.
         * @param feature Fonctionnalité à comparer
         */
        private isSelectedLv1(feature: Feature){
            return this.selectedlv1 === feature.Path;
        }
        /**
         * Change la fonctionnalité mère (level1) sélectionnée.
         * @param feature Fonctionnalité à inscrire
         */
        private setSelectedlv1(feature: Feature){
            this.selectedlv1 = this.selectedlv1 === feature.Path ? "" : feature.Path;
        }

        /**
         * Récupère la path de fonctionnalité niveau 1 à partir d'un autre d'une fonctionnalité
         * @param feature Fonctionnalité cible
         */
        private getRootFeaturePath(featurePath: string): string {
            // On décompose le "path"
            let split : string[] = featurePath.split(' / ');
            // Si le "path" est valide alors on traite
            if(split.length > 0) {
                // On récupère le path de la fonctionalitée racine de "level 1"
                return split[0];
            }
            return "";
        }

        /**
		 * Sélection d'une fonction avec mise à jour du store global
		 * @param selectedFeature Fonction sélectionnée à charger
		 */
		public selectFeature(selectedFeature: Feature) {
			if (selectedFeature.Target) {
                this.featurePathCurrent = selectedFeature.Path;
                /** Change l'ouverture du "b-collapse" sur la nouvelle fonctionnalité sélectionnée en cours. */
                this.selectedlv1 = this.getRootFeaturePath(selectedFeature.Path);

                // Chemin complet de la fonction avec le label de la fonction parente
                let pathArray = selectedFeature.Path.split(" / ");

                let pathLabels: string = "";
                for (let i = 1; i < pathArray.length; i++) {
                    pathLabels += '/ ' + this.$t(pathArray[i]) + " ";
                };
                
                /** Retire le 1er caractère '/' */
                if (pathLabels && pathLabels.length > 2)
                    pathLabels = pathLabels.substring(2);

                // Emet une action de changement de fonction courante avec la fonction sélectionnée en paramètre
                this.$store.dispatch("SetFeature", selectedFeature.Path);

                this.$emit("selectFeatureEvent", selectedFeature);
            }
            else
            {
                this.selectFeature(selectedFeature.Features.at(0));
            }
		}
        
        // *** Initialisation ***

        /** Methode d'initialisation de la vue */
        async created() {
            /** Chargement des traductions des features */
            this.$root.$i18n.mergeLocaleMessage(this.$i18n.locale, featuresLocales[this.$i18n.locale]);

            this.featurePathCurrent = this.defaultPath;
            /** Initialise l'ouverture du "b-collapse" sur la fonctionnalité sélectionnée en cours. */
            this.selectedlv1 = this.getRootFeaturePath(this.defaultPath);
        }
    }
</script>

<style scoped>
    :deep(.featureMenuItem:hover) {
        background-color: var(--gray) !important;
    }
    .border-left-2-only{
        border-left: 2px solid;
        border-right: 0;
        border-top: 0;
        border-bottom: 0;
    }
</style>